module.exports = __webpack_public_path__ + "static/img/s14.2aa372d1.png";